module.exports = __webpack_public_path__ + "media/application/images/demsoc/tiles/monochrome_2-4528bfc3eda83133140edecadf16ddd6.jpg";